import { render, staticRenderFns } from "./chooseStaffModal.vue?vue&type=template&id=af42df26&scoped=true&"
import script from "./chooseStaffModal.vue?vue&type=script&lang=js&"
export * from "./chooseStaffModal.vue?vue&type=script&lang=js&"
import style0 from "./chooseStaffModal.vue?vue&type=style&index=0&id=af42df26&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af42df26",
  null
  
)

export default component.exports